/**
 * <load-more-products> — progressively enhances the load-more link.
 * Fetches the next page, extracts new product cards, appends them.
 * Falls back to standard pagination if JS fails or is disabled.
 */

class LoadMoreProducts extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-load-more]');
    if (!this.button) return;

    this.label = this.querySelector('[data-load-more-label]');
    this.spinner = this.querySelector('[data-load-more-spinner]');
    this.progress = this.querySelector('.collection-grid__load-more-progress');
    this.list = this.querySelector('[data-grid-items]');

    this.button.addEventListener('click', this.handleClick.bind(this));

    this.bindToolbar();
  }

  bindToolbar() {
    const form = document.getElementById(`CollectionFilterForm-${this.dataset.sectionId}`);
    if (!form) return;

    const sortSelect = form.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => form.submit());
    }
  }

  async handleClick(event) {
    event.preventDefault();
    if (this.button.dataset.loading === 'true') return;

    const url = this.button.href;
    this.setLoading(true);

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newItems = doc.querySelectorAll('[data-grid-items] > li');
      newItems.forEach((item) => this.list.appendChild(item.cloneNode(true)));

      const nextLoadMore = doc.querySelector('[data-load-more]');
      const newProgress = doc.querySelector('.collection-grid__load-more-progress');

      if (nextLoadMore) {
        this.button.href = nextLoadMore.href;
      } else {
        this.button.parentElement?.remove();
      }

      if (this.progress && newProgress) {
        this.progress.textContent = newProgress.textContent;
      }

      window.history.replaceState({}, '', url);
    } catch (err) {
      console.error('Load more failed:', err);
      window.location.href = url;
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    this.button.dataset.loading = String(isLoading);
    if (this.label) this.label.hidden = isLoading;
    if (this.spinner) this.spinner.hidden = !isLoading;
  }
}

customElements.define('load-more-products', LoadMoreProducts);
